<template>
    <div class="scl-ad">
        <PreLoader v-if="isLoading"/>
        <div class="header-title text-center" v-html="$t('quarter')"/>

        <v-card width="max-content" class="card-main" v-if="schoolQuarters.length">
            <v-card-text class="card-element" v-for="quarter in schoolQuarters" :key="quarter.id">
                <span class="card-txt-title" v-html="quarterTitle[quarter.semester]"/>
                <v-menu v-model="quarter.showPickerFrom" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field outlined dense v-model="quarter.startDate" :label="$t('from')"
                                      append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"/>
                    </template>
                    <v-date-picker locale="ru-RU" v-model="quarter.dateStart"
                                   @input="onSelectQuarterDate(quarter, 'showPickerFrom')"/>
                </v-menu>
                <v-menu v-model="quarter.showPickerTo" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field outlined dense v-model="quarter.endDate" :label="$t('to')"
                                      append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"/>
                    </template>
                    <v-date-picker locale="ru-RU" v-model="quarter.dateEnd"
                                   @input="onSelectQuarterDate(quarter, 'showPickerTo')"/>
                </v-menu>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="card-element card-btn">
                <v-btn color="primary" @click="generateQuarters" v-html="$t('autogenerate')"/>
                <v-btn color="green" @click="submitSave" v-html="$t('save')"/>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { QuarterService } from '@/_services/quarter.service'
import moment from 'moment'
import PreLoader from '@/components/preloader/PreLoader'
const quarterService = new QuarterService()

export default {
  name: 'quarter',
  components: {
    PreLoader
  },

  data () {
    return {
      isLoading: false,
      quarterTitle: {
        1: 'I ' + this.$t('quarter'),
        2: 'II ' + this.$t('quarter'),
        3: 'III ' + this.$t('quarter'),
        4: 'IV ' + this.$t('quarter')
      },
      schoolQuarters: []
    }
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },

  mounted () {
    this.isLoading = true
    this.getQuartersBySchool()
  },

  methods: {
    getQuartersBySchool () {
      quarterService.getBySchoolAndChronicle(this.school.id, this.school.chronicleId).then((res) => {
        this.schoolQuarters = res.map((quarter) => {
          quarter.dateStart = quarter.startDate
          quarter.dateEnd = quarter.endDate
          quarter.startDate = moment(quarter.startDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
          quarter.endDate = moment(quarter.endDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
          quarter.showPickerFrom = false
          quarter.showPickerTo = false
          quarter.status = true
          return quarter
        }).sort((a, b) => a.semester - b.semester)
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    generateQuarters () {
      if (!this.schoolQuarters.length) {
        this.isLoading = true
        quarterService.generateQuarter(this.school.id, this.school.chronicleId).then(() => {
          this.getQuartersBySchool()
        }).catch((err) => this.$toast.error(err))
      }
    },

    onSelectQuarterDate (quarter, showPicker) {
      quarter[showPicker] = false
      quarter.startDate = moment(quarter.dateStart, 'YYYY-MM-DD').format('DD.MM.YYYY')
      quarter.endDate = moment(quarter.dateEnd, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },

    async submitSave () {
      this.isLoading = true
      const requests = this.schoolQuarters.map((quarter) => {
        return new Promise((resolve, reject) => {
          quarterService.edit(quarter).then((res) => {
            resolve(res)
          }).catch((err) => {
            reject(err)
            this.$toast.error(err)
            this.isLoading = false
          })
        })
      })
      const results = await Promise.all(requests)
      if (results.length) {
        this.$toast.success(this.$t('success'))
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-main{
    margin: 0 auto;
    padding-top: 20px
}
.card-txt-title{
    font-weight: bold;
    color: black;
    font-size: 16px;
    padding-bottom: 25px;
    width: 100px;
}
.card-element{
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
}
.card-btn{
    padding: 20px 0;
    justify-content: center;
}
    .quarter-calendar {
        margin: 0; padding: 10px;
        .all-quarters {
            background: #fff;
            //width: 865px;
            width: max-content;
            margin: 0 auto;
            padding: 20px;
            flex-wrap: nowrap;
            border-radius: 8px;
            .quarter {
                display: flex;
                align-items: center;
                justify-content: center;
                .quarter-name, .date-from {
                    margin-right: 20px;
                }
            }
        }
    }
.header-title {
    margin-bottom: 15px;
    font-size: 28px;
    font-weight: bold;
}
    @media (max-width: 420px) {
        .card-element{
            flex-wrap: wrap;
            justify-content: center;
            width: 100%;
        }
        .card-txt-title{
            padding-bottom: 0!important;
        }
        .header-title{
            font-size: 20px!important;
            width: 100%;
            text-align: center;
        }
    }
</style>
